import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import bound from 'promise.prototype.finally';
import * as myMessage from '@/utils/message';
import * as path from '@/helpers/path';
import '@/helpers/permission';
import 'normalize.css';
import '@/styles/index.scss';
import 'element-ui/lib/theme-chalk/index.css';
import { encryptionPhoneNumber, encryptionAddress, priceRule } from '@/utils';
// import './registerServiceWorker'   脚手架自带的，完了看干嘛的

require('./mock'); // 引入mock数据，关闭则注释该行
// require('./mock/index2'); // 引入mock数据，关闭则注释该行

bound.shim();

Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'small' });

export default new Vue({
  router,
  store,
  render: h => h(App),
  provide: {
    path,
    myMessage,
    encryptionPhoneNumber,
    encryptionAddress,
    priceRule
  }
}).$mount('#app');
